module.exports = __webpack_public_path__ + "img/京豆.7e75f861.png";